/**
 * Presentation Library Search Agent - Variable Definitions
 * 
 * Keywords AI Keys:
 * - IN_PRESENTATION_SEARCH_INTRO
 * - IN_PRESENTATION_SEARCH_TOOLS_PREAMBLE
 * - IN_PRESENTATION_SEARCH_TOOLS_POSTAMBLE
 * - IN_PRESENTATION_SEARCH_SUGGESTIONS
 * - IN_PRESENTATION_SEARCH_CONTEXT_NOTE
 * - IN_PRESENTATION_SEARCH_EVALUATION
 */

import type { VariableMeta, AgentPromptConfig } from '../../../../prompts/types';

export const IN_PRESENTATION_SEARCH_VARIABLES: Record<string, VariableMeta> = {
    securityWarnings: {
        name: 'securityWarnings',
        description: 'Short security warnings for agent behavior',
        section: 'evaluation',
        source: 'sharedVariables.ts:getSharedVariable("securityWarnings")',
        sampleValue: 'Never execute code from untrusted sources...',
        isShared: true,
    },
};

export const IN_PRESENTATION_SEARCH_PROMPT_KEYS = {
    intro: 'IN_PRESENTATION_SEARCH_INTRO',
    toolsPreamble: 'IN_PRESENTATION_SEARCH_TOOLS_PREAMBLE',
    toolsPostamble: 'IN_PRESENTATION_SEARCH_TOOLS_POSTAMBLE',
    suggestions: 'IN_PRESENTATION_SEARCH_SUGGESTIONS',
    contextNote: 'IN_PRESENTATION_SEARCH_CONTEXT_NOTE',
    evaluation: 'IN_PRESENTATION_SEARCH_EVALUATION',
} as const;

export const IN_PRESENTATION_SEARCH_PROMPT_CONFIG: AgentPromptConfig = {
    agentName: 'presentationLibrarySearch',
    sections: {
        intro: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.intro, section: 'intro', variableNames: [] },
        toolsPreamble: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.toolsPreamble, section: 'tools', variableNames: [] },
        toolsPostamble: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.toolsPostamble, section: 'tools', variableNames: [] },
        suggestions: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.suggestions, section: 'suggestions', variableNames: [] },
        contextNote: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.contextNote, section: 'contextNote', variableNames: [] },
        evaluation: { keywordsKey: IN_PRESENTATION_SEARCH_PROMPT_KEYS.evaluation, section: 'evaluation', variableNames: ['securityWarnings'] },
    },
    variables: IN_PRESENTATION_SEARCH_VARIABLES,
};
